import { z } from "zod";
import { EProjectWhatIsNextStatus } from "../types/Project";
import { mediasSchema } from "./common";

// form zod validation schema
export const createProjectSchema = z.object({
  name: z.string().min(1, { message: "This field is required" }),
  area: z.number().or(z.string()).optional(),
  tenure: z.string().optional(),
  description: z.string().optional(),
  address: z.string().optional(),
  categoryId: z.string().optional(),
  developerId: z.string().optional(),
  tenureEffectFrom: z.date().nullable().optional(),
  expectedTop: z.date().optional(),
  previewDate: z.string().optional(),
  targetPreviewLaunchDateMonth: z.string().optional(),
  targetPreviewLaunchDateYear: z.number().or(z.string()).optional(),
  locationId: z.string().optional(),
  marketSegment: z.string().optional(),
  pictures: z
    .array(
      z.object({
        id: z.string().min(1, { message: "This field is required" }),
        size: z.number().or(z.string()).optional(),
        url: z.string().min(1, { message: "This field is required" }),
        name: z.string().optional(),
        type: z.string().min(1, { message: "This field is required" }),
      }),
    )
    .optional(),

  medias: z
    .array(
      z.object({
        id: z.string().min(1, { message: "This field is required" }),
        size: z.number().or(z.string()).optional(),
        url: z.string().min(1, { message: "This field is required" }),
        name: z.string().optional(),
        type: z.string().min(1, { message: "This field is required" }),
        disabled: z.boolean().optional(),
      }),
    )
    .optional(),
  amenityHtml: z.string().optional(),
  facilityHtml: z.string().optional(),
  directCommission: z.number().or(z.string()).optional(),
  googleMapUrl: z.string().optional(),
  totalUnitsCount: z.number().or(z.string()).optional(),
  availableUnitsCount: z.number().or(z.string()).optional(),
  manualTotalUnitsCount: z.number().or(z.string()).optional(),
  manualAvailableUnitsCount: z.number().or(z.string()).optional(),
  siteplanImages: mediasSchema.optional(),
  desktopLogo: mediasSchema.optional(),
  desktopLogoId: z.string().optional(),
  whatIsNextStatus: z
    .enum(Object.values(EProjectWhatIsNextStatus) as [string, ...string[]])
    .default(EProjectWhatIsNextStatus.PreLaunch)
    .optional(),
  brochureAsset: mediasSchema.optional(),
  broChureAssetId: z.string().optional(),
  whatIsNextStatusOptions: z
    .array(
      z.enum(Object.values(EProjectWhatIsNextStatus) as [string, ...string[]]),
    )
    .default([
      EProjectWhatIsNextStatus.PreLaunch,
      EProjectWhatIsNextStatus.Preview,
      EProjectWhatIsNextStatus.PostLaunch,
    ])
    .optional(),
  slug: z.string().optional(),
  showflatLocation: z.string().optional(),
  isShowflatLocation: z.boolean().optional(),
  // Hero Image
  heroImage: mediasSchema.optional(),
  // Hero Content
  catchphrase: z.string().optional(),
  headline: z.string().optional(),
  shortDescription: z.string().optional(),
  // Site Plan
  sitePlanTitle: z.string().optional(),
  sitePlanDescription: z.string().optional(),
  // Location
  locationTitle: z.string().optional(),
  locationImage: mediasSchema.optional(),
  // Education
  educationTitle: z.string().optional(),
  educationDescription: z.string().optional(),
  educationImage: mediasSchema.optional(),
  // Transport
  transportTitle: z.string().optional(),
  transportDescription: z.string().optional(),
  transportImage: mediasSchema.optional(),
  // Amenity
  amenityTitle: z.string().optional(),
  amenityDescription: z.string().optional(),
  amenityImage: mediasSchema.optional(),
  // SEO
  seoText: z.string().optional(),
  // Image IDs (UUID for API)
  heroImageId: z.string().optional(),
  locationImageId: z.string().optional(),
  educationImageId: z.string().optional(),
  transportImageId: z.string().optional(),
  amenityImageId: z.string().optional(),
});

// generate form types from zod validation schema
export type CreateProjectInput = z.infer<typeof createProjectSchema>;
